import { render } from "./ClientCMSProductRoot.vue?vue&type=template&id=337ba1a2&scoped=true"
import script from "./ClientCMSProductRoot.vue?vue&type=script&lang=js"
export * from "./ClientCMSProductRoot.vue?vue&type=script&lang=js"

import "./ClientCMSProductRoot.vue?vue&type=style&index=0&id=337ba1a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337ba1a2"]])

export default __exports__